/**
 * Waits for the specified amount of time in milliseconds before resolving.
 */

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
